import { LocationTableItemResponse } from '../interfaces'

export const toTableRowItems = (items: LocationTableItemResponse[]) =>
  items.map((item: LocationTableItemResponse) => ({
    id: item.id,
    name: item.name ?? '',
    code: item.code ?? '',
    legalEntityName: item.legalEntityName ?? '',
    subtypeTypeName: item.typeName ?? '',
    subtypeName: item.subtypeName ?? '',
    locationStatusName: item.locationStatusName ?? '',
    regionList: item.regionList ?? []
  }))
